import { cn } from '@/lib/utils'
import React from 'react'

interface LoadingDotsProps {
  className?: string
  size?: number
  color?: string
}

const LoadingDots: React.FC<LoadingDotsProps> = ({
  className,
  size = 8,
  color = 'currentColor',
}) => {
  return (
    <div className={cn('flex space-x-1', className)}>
      <div
        style={{ width: size, height: size, backgroundColor: color }}
        className="animate-bounce rounded-full [animation-delay:-0.3s]"
      />
      <div
        style={{ width: size, height: size, backgroundColor: color }}
        className="animate-bounce rounded-full [animation-delay:-0.15s]"
      />
      <div
        style={{ width: size, height: size, backgroundColor: color }}
        className="animate-bounce rounded-full"
      />
    </div>
  )
}

export default LoadingDots
